import React, { useEffect, useState } from "react";
import { useNavigate,useSearchParams,useParams } from "react-router-dom";
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";

import "./scss/index.scss";
import Color from "@tool/color";
import AppLoading from "@con/app-loading";
import AppLogin from "@con/app-login";
import moSkin, { skinInit } from "@store/skin";
import { getBaseInfo } from "@store/user";
import moUser from "@store/user";
import { toggleValue } from "@/store";
import Budget from "./budget";
import Hobby from "./hobby";
import { welfareInit } from "./store/wealfare";
import moIndex from "../store";
import { newUrl } from '@/tool';
interface IProps {}
interface IState {}

const Wealfare = (props: IProps, state: IState) => {
  const navi = useParams();
  const { industry } = moIndex;
  const [searchParams] = useSearchParams();
  const init = async () => {
    // console.log(55555)
    toggleValue("isLoading", true);
    await welfareInit();
    // const budget: any = document.getElementById("budget");
    // const hobby: any = document.getElementById("hobby");
    // if (navi.id === "0") {
    //   const top = budget.offsetTop;
    //   window.scrollTo(0, 0);
    // }
    // if (navi.id === "1") {
    //   const top = budget.offsetTop;
    //   window.scrollTo(0, top + 90);
    // }
    // if (navi.id === "2") {
    //   const top = hobby.offsetTop;
    //   window.scrollTo(0, top + 90);
    // }
    toggleValue("isLoading", false);
    setTimeout(() => {
      toggleValue("isLoading", false);
    }, 500);
  };

  useEffect(() => {

    const industryCode = searchParams.get('industryCode');
    const categoryName = searchParams.get('categoryName');
    // if (industry.code) {
      newUrl({title:'人力核心指标_福利洞察',industryName: categoryName || industry.name,industryCode:industryCode|| industry.code},['title','industryName'],navi)
      init();
    // }
    // return () => {};
  }, []);

  useEffect(() => {
    const budget: any = document.getElementById("budget");
    const hobby: any = document.getElementById("hobby");
    debugger;
    if (navi.id === "0") {
      const top = budget.offsetTop;
      window.scrollTo(0, 0);
    }
    if (navi.id === "1") {
      const top = budget.offsetTop;
      window.scrollTo(0, top + 90);
    }
    if (navi.id === "2") {
      const top = hobby.offsetTop;
      window.scrollTo(0, top + 90);
    }
    // const industryCode = searchParams.get('industryCode');
    // const categoryName = searchParams.get('categoryName');
    // newUrl({title:'人力核心指标_福利洞察',industryName: categoryName || industry.name,industryCode:industryCode|| industry.code},['title','industryName'],navi)
    return () => {};
  }, [document.title]);

  return (
    <section className="wealfare-page-warp">
      <Budget />
      <Hobby />
      <AppLoading />
    </section>
  );
};

export default observer(Wealfare);
